<div [formGroup]="parts" class="tel-input-container" fxLayout.xs="row wrap">
    <!-- <input class="tel-input-element" formControlName="country" size="3" aria-label="Country code"
        (input)="_handleInput()" [matAutocomplete]="countryCode">
    <mat-autocomplete #countryCode="matAutocomplete">
        <mat-option *ngFor="let option of countryCodes" [value]="option">
            {{option}}
        </mat-option>
    </mat-autocomplete> -->

    <mat-select formControlName="country" (selectionChange)="countryChanged();_handleInput();" class="w-60" required>
        <mat-option *ngFor="let option of countryCodes" [value]="option">
            +{{option}}
        </mat-option>
    </mat-select>

    <span class="tel-input-spacer">-</span>
    <!-- <input class="tel-input-element" formControlName="provider" size="2" aria-label="Provider code"
        (input)="_handleInput()" [matAutocomplete]="providerCode">
    <mat-autocomplete #providerCode="matAutocomplete">
        <mat-option *ngFor="let option of phonePrefixes[parts.get('country').value]" [value]="option">
            {{option}}
        </mat-option>
    </mat-autocomplete> -->

    <mat-select formControlName="provider" (selectionChange)="_handleInput()" class="w-40" required>
        <mat-option *ngFor="let option of phonePrefixes[parts.get('country').value]" [value]="option">
            {{option}}
        </mat-option>
    </mat-select>

    <span class="tel-input-spacer">-</span>
    <input class="tel-input-element text-left" formControlName="phone" aria-label="Phone number"
        (input)="_handleInput()">
</div>

<!-- <div class="error-message"><span *ngIf="parts.get('country').errors">Missing country number. </span><span
        *ngIf="parts.get('provider').errors">Missing provider number. </span><span
        *ngIf="parts.get('phone').errors">Missing phone number. </span></div> -->